import { guid } from "traveldesk-ui"

export class BookingCustomInput {
    id: number = 0
    externalId: string = ''
    name: string = ''
    description: string = ''
    translations: BookingCustomInputTranslation[] = []
    type: BookingCustomInputType = BookingCustomInputType.Text
    minNumber?: number
    maxNumber?: number
    price?: number
    items: BookingCustomInputSelectOption[] = []

}
export enum BookingCustomInputType {
    Select = 1, MultiSelect, Number, Text, Boolean, Date, File, Address, Time, DateTime,
}
export const BookingCustomInputTypeOptions = [
    { value: BookingCustomInputType.Select, label: 'Select' },
    { value: BookingCustomInputType.MultiSelect, label: 'Multi Select' },
    { value: BookingCustomInputType.Number, label: 'Number' },
    { value: BookingCustomInputType.Text, label: 'Text' },
    { value: BookingCustomInputType.Boolean, label: 'Boolean' },
    { value: BookingCustomInputType.Date, label: 'Date' },
    { value: BookingCustomInputType.File, label: 'File' },
    { value: BookingCustomInputType.Address, label: 'Address' },
]
export class BookingCustomInputTranslation {
    languageId: number = 0
    name: string = ''
    description: string = ''
    bookingCustomInputId: number = 0


}
export class BookingCustomInputSelectOption {
    id: number = 0
    guid: string = guid()
    label: string = ''
    value: string = ''
    price?: number
    translations: BookingCustomInputSelectOptionTranslation[] = []
}
export class BookingCustomInputSelectOptionTranslation{
    languageId: number = 0
    label: string = ''
    bookingCustomInputSelectOptionId: number = 0
}